import React, { useEffect, useState } from 'react';
import { Table, Button, Row, Col, notification, Select } from 'antd';
import { IoMdDocument } from "react-icons/io";
import { RiFileExcel2Fill } from "react-icons/ri";
import { getAcc } from '../services/accountService';
import ReactExport from "react-export-excel";

const { Option } = Select;
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function Account(){
  const[dataTableCompleta, setDataTableCompleta] = useState([]);
  const[tableLoading, setTableLoading] = useState(false);
  const[accountLoading, setAccountLoading] = useState(false);
  const[dataAccount, setDataAccount] = useState([]);
  const[selectedAccounts, setSelectedAccounts] = useState([]);
  const[btnExcelVisible, setBtnExcelVisible] = useState(false);

    useEffect(() => {
        async function accounts(){
            setAccountLoading(true);
            const request = {
                "Accounts" : []
            }
            const { data } = await getAcc(request);
            setDataAccount(data);
            setAccountLoading(false);
        }
        accounts();
        
    },[])

    const msNotification = (type, title, desc) => {
      notification[type]({
        message: title,
        description:
          desc,
      });
    };

    function handleChangeAccounts(value) {
        setSelectedAccounts(value);
        
    }

    const handleClickReport = async () =>{
      setDataTableCompleta([]);
      setBtnExcelVisible(false);
      const request = {
        "Accounts" : selectedAccounts
      }
      setTableLoading(true);
      async function getReport(){
        const { data } = await getAcc(request);
        if(data.length === 0){
          msNotification('info', 'Reporte', 'No se encontraron datos con los filtros seleccionados.' );
          setTableLoading(false);
          return false;
        }else{
          setBtnExcelVisible(true);
        }
        
        setDataTableCompleta(data);
        setTableLoading(false);
      }
      getReport();
    }

    const formatNumber = (number)=>{
      let imp = ((number * 100) / 100).toFixed(2);
      return imp;
    }

    const rowClassColor = (record, index) => record.value >= 0 ? 'rowGreen' : 'rowRed';

    const columnsComplete = [
      {
        title: 'ID',
        dataIndex: 'id',
        width: 100,
        fixed: 'left'
      },
      {
        title: 'Cuenta',
        dataIndex: 'name',
        render: (value) => (value)
      },
      {
        title: 'Importe',
        dataIndex: 'value',
        render: (value) => (`$ ${formatNumber(value)}`)
      },
     
      
    ];
    
    

    return(
      <div className="mainContainer">

        <Row>
            <Col span={24}>
                <h1 className="title">Reporte de estado de cuentas</h1>
                <hr className="hr-title"/>
            </Col>
        </Row>

        <Row className="detailContainer">
          <Col span={20}></Col>
          <Col span={4}>
            <div className="">
              <Button block type="primary" icon={<IoMdDocument/>} onClick={handleClickReport}>
                &nbsp; Generar
              </Button>
            </div>
          </Col>
          <Col span={24}><br /></Col>

          <Col span={8}>
            <Select mode="multiple" loading={accountLoading} style={{ width: '100%' }} 
              onChange={handleChangeAccounts} 
              placeholder="Cuentas..."
              maxTagCount='responsive'>
                {dataAccount.map(function(obj){
                    return <Option key={obj.id} value={obj.id}>{obj.name}</Option>
                })}
            </Select>
          </Col>
          <Col span={16}></Col>
          <Col span={24}><br /></Col>
          
          <Col span={24}>
            <Row>
                <Col span={24}><br /></Col>
                <Col span={6} className={"collapse" + (btnExcelVisible ? 'in' : '')}>
                <ExcelFile filename="Reporte-Estado-Cuentas" element={<Button block type="primary" icon={<RiFileExcel2Fill/>}> Descargar datos</Button>}>
                    <ExcelSheet data={dataTableCompleta} name="Estado de cuentas">
                        <ExcelColumn label="ID" value={(col) => col.id}/>
                        <ExcelColumn label="Cuenta" value="name"/>
                        <ExcelColumn label="Importe" value={(col) => `$ ${formatNumber(col.value)}`}/>
                    </ExcelSheet>
                    
                </ExcelFile>
                </Col>
                <Col span={24}>
                <br/>
                <Table rowKey="key" dataSource={dataTableCompleta} columns={columnsComplete} 
                    loading={tableLoading}
                    rowClassName={rowClassColor}/>
                </Col>
            </Row>
          </Col>
              
        </Row>
      </div>
    );
}

export default Account;



// WEBPACK FOOTER //
// ./src/components/Account.jsx